module.exports = __webpack_public_path__ + "img/Pratik-giri.ea761e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial/Pratik-giri.jpg
// module id = 1070
// module chunks = 1